export class TNCFilter {
  Units: number[] = [];
  PageSize: number = 0;
  PageIndex: number = 50;
  OrderdByColoumName: string;
  OrderdBy: string;
  SearchText: string;
  FromDate: Date = null;
  ToDate: Date = null;
  Departments: number[] = [];
  UserId: number;
  StatusId: number[] = [];
  TrainingId: number[] = [];
  SelectAll: boolean;
  CurrentPage: number;
  Users: number[] = [];
}
